import { render, staticRenderFns } from "./OpenCartIcon.vue?vue&type=template&id=10e22836&scoped=true"
import script from "./OpenCartIcon.vue?vue&type=script&lang=js"
export * from "./OpenCartIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e22836",
  null
  
)

export default component.exports